<template>
	<v-container grid-list-xs>
		<v-form>
			<v-card>
				<v-card-title primary-title class="text-uppercase">
					<v-btn icon @click="
						$inertia.visit($route('central.reservations.index'))
					">
						<v-icon>mdi-arrow-left</v-icon>
					</v-btn>
					{{ $t("title.create_reservation") }}
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout row wrap>
							<v-flex xs12>
								<v-card flat color="transparent">
									<v-card-title primary-title>
										Customer
										<v-spacer></v-spacer>
										<CustomerCreateForm></CustomerCreateForm>
									</v-card-title>
									<v-card-text>
										<ReservationCustomerForm v-model="item" :customers="customers">
										</ReservationCustomerForm>
									</v-card-text>
								</v-card>
							</v-flex>
							<v-flex xs12>
								<form-reservation v-model="item" :outlets="outlets"></form-reservation>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click.native="submit()" :loading="item.processing">
						<v-icon left>mdi-content-save</v-icon>
						{{ $t("Save") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-container>
</template>
<script>
import CustomerCreateForm from "@Reservation/components/CustomerCreateForm.vue";
import ReservationCustomerForm from "@Reservation/components/ReservationCustomerForm.vue";
import debounce from "lodash.debounce";
export default {
	components: {
		CustomerCreateForm,
		ReservationCustomerForm,
	},
	props: ["outlets", "customers"],
	data() {
		return {
			item: this.$inertia.form({
				customer_id: null,
				outlet_id: null,
				adults: 0,
				children: 0,
				date: null,
				time: null,
				description: null,
				status: "pending",
				table_id: null,
				customer: {},
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(this.$route("central.reservations.store"));
		},

		openCustomerForm() {
			try {
				this.customer = this.$inertia.form({
					image: {},
					first_name: null,
					last_name: null,
					female: null,
					male: null,
					birthday: null,
					phone: null,
					email: null,
					company_name: null,
					address: null,
					city: null,
					telegram: null,
					language: null,
					title: null,
					active: true,
					response: "json",
				});

				this.$wait.start("form customer");
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},

	watch: {
		search(...args) {
			this.debouncedWatch(...args);
		},
	},

	created() {
		this.debouncedWatch = debounce((newValue, oldValue) => {
			this.$wait.start("search");
			axios
				.get(
					this.$route("central.reservation.search.customer", {
						search: newValue,
					})
				)
				.then((response) => {
					if (response.status == 200) {
						this.customers_data = response.data.data;
					}
				})
				.finally(() => {
					this.$wait.end("search");
				});
		}, 500);
	},
	beforeUnmount() {
		this.debouncedWatch.cancel();
	},
};
</script>